import { useState, useEffect, useMemo} from 'react';
import { Typography, Paper, Select, MenuItem, FormControl, InputLabel, Autocomplete, TextField, Button, Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { myApi } from '../../config/axiosConfig';
import MiTabla from '../../components/plantilla/tabla/MiTabla';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import {
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend
} from 'recharts';

const Reporte_Loves = () => {

    const [data, setData] = useState([]);

    const [loading, setLoading] = useState(false);

    const [tipoReporte, setTipoReporte] = useState('0');

    const [productos, setProductos] = useState([]);
    const [operadores, setOperadores] = useState([]);
    
    const [filtroProducto, setFiltroProducto] = useState('');
    const [filtroOperador, setFiltroOperador] = useState('');

    const [topN, setTopN] = useState('');

    const meses = [
        { label: 'TODOS', value: 0 },
        { label: 'ENERO', value: 1 },
        { label: 'FEBRERO', value: 2 },
        { label: 'MARZO', value: 3 },
        { label: 'ABRIL', value: 4 },
        { label: 'MAYO', value: 5 },
        { label: 'JUNIO', value: 6 },
        { label: 'JULIO', value: 7 },
        { label: 'AGOSTO', value: 8 },
        { label: 'SEPTIEMBRE', value: 9 },
        { label: 'OCTUBRE', value: 10 },
        { label: 'NOVIEMBRE', value: 11 },
        { label: 'DICIEMBRE', value: 12 }
    ];
    const anioActual = new Date().getFullYear();
    const anios = Array.from({ length: 6 }, (_, i) => anioActual - i);
    const [anioSeleccionado, setAnioSeleccionado] = useState([]);
    const [mesSeleccionado, setMesSeleccionado] = useState([]);

    const campos = {
        '0': { field: 'product', headerName: 'PRODUCTO' },
        '1': { field: 'mes', headerName: 'MES' },
        '2': { field: 'semana', headerName: 'SEMANA' },
        '3': { field: 'fecha', headerName: 'FECHA' },
        '4': { field: 'operador', headerName: 'OPERADOR' },
        '5': { field: 'fecha', headerName: 'FECHA' },
    };

    const campoActual = campos[tipoReporte] || campos['0'];

    //Función para formatear la fecha
    const formatDate = (date) => {
        const options = {
            year: '2-digit', // Año con dos dígitos
            month: '2-digit', // Mes con dos dígitos
            day: '2-digit', // Día con dos dígitos
            hour: '2-digit', // Hora con dos dígitos
            minute: '2-digit', // Minutos con dos dígitos
            second: '2-digit',    // Segundos con dos dígitos
            hour12: false, // Formato de 24 horas
        };
    
        const formattedDate = new Date(date).toLocaleString('en-US', options);
    
        // Formato deseado: MM/DD/YY HH:mm
        const [datePart, timePart] = formattedDate.split(', '); // Separar fecha y hora
        const [month, day, year] = datePart.split('/'); // Separar mes, día y año
        //const formattedDateTime = `${month}/${day}/${year} ${timePart.slice(0, 5)}`; // Construir el formato
        const formattedDateTime = `${month}/${day}/${year} ${timePart}`; // Construir el formato
    
        return formattedDateTime;
    };

    const columnsBase = [
        {
            field: campoActual.field,
            headerName: campoActual.headerName,
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {

                const valor = params;
                
                if(valor === 'TOTAL GENERAL')
                    return valor;

                if (campoActual.field === 'mes') {
                    const mes = meses.find((m) => m.value === valor);
                    return mes?.label || '';
                }
                if (campoActual.field === "fecha") 
                {
                    const formatted = formatDate(params); 
                    return formatted.substring(0, 8);
                }

                return valor;
            }
        },
/*         { field: 'transacciones', headerName: 'TRANSACCIONES',
            headerAlign: "center",
            align: "center",
        }, */
        { field: 'galones', headerName: 'GALONES',
            headerAlign: "center",
             align: "right",
            type: "number",
            renderCell: (params) => (
                // Formatear el valor de la celda como moneda con "$" y separador de miles
                `${params.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            )
        },
        { field: 'importe', headerName: 'IMPORTE',
            headerAlign: "center",
            align: "right",
            type: "number",
            renderCell: (params) => (
                // Formatear el valor de la celda como moneda con "$" y separador de miles
                `$${params.value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            )
        }
    ];

    let dynamicColumn;

    if (tipoReporte == 5) {
        dynamicColumn = {
            field: 'unidad',
            headerName: 'UNIDAD',
            headerAlign: "center",
            align: "center"
        };
    } else {
        dynamicColumn = {
            field: 'transacciones',
            headerName: 'TRANSACCIONES',
            headerAlign: "center",
            align: "center"
        };
    }

    const columns = [
        columnsBase[0],       // Campo dinámico principal (ej. fecha o mes)
        dynamicColumn,        // Columna dinámica: transacciones o unidad
        ...columnsBase.slice(1) // Galones e importe
    ];

    const fetchData = async () => 
    {
        setLoading(true);
        try 
        {
            const datosEnviados = { tipoReporte, filtroProducto, mesSeleccionado, anioSeleccionado, topN, filtroOperador };
            const response = await myApi.post('/loves/getLovesReport', datosEnviados);

            //console.log(response)

            if (response?.data) 
            {
                setData(response.data);
            } 
            else 
            {
                setData([]);
            }
        } 
        catch(error) 
        {
            console.error('Error fetching report:', error);
            setData([]);
        } 
        finally 
        {
            setLoading(false);
        }
    };

    const fetchDatos = async () => 
    {
        try 
        {
            const [productosRes, operadoresRes] = await Promise.all([
                myApi.get('loves/catalogos/products'),
                myApi.get('loves/catalogos/drivers')
            ]);

            setProductos(productosRes.data.data.map(p => ({
                value: p.product, label: p.product
            })));
            setOperadores(operadoresRes.data.data.map(d => ({
                value: d.driver, label: d.driver
            })));
        } 
        catch(err) 
        {
            console.error('Error al cargar datos', err);
        }
    };

    useEffect(() => 
    {
        fetchDatos();
    }, []);

    useEffect(() => 
    {
        fetchData();
    }, []);

    useEffect(() => {
        if (tipoReporte === "5") 
        {
            if (!filtroOperador) 
            {
                Swal.fire("Atención", "Debe seleccionar un operador para este tipo de reporte.", "warning");
                setTipoReporte("0");
                return;
            }
        }

        fetchData();
    }, [filtroProducto, tipoReporte, mesSeleccionado, anioSeleccionado, topN, filtroOperador]);

    const reportTitles = {
        '0': 'Consumo Total',
        '1': 'Consumo por Mes',
        '2': 'Consumo por Semana',
        '3': 'Consumo por Día',
        '4': 'Consumo Top N',
        '5': 'Consumo por Operador',
    };

    const mesesLabels = ["", "ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"];

    const safeData = Array.isArray(data) ? data : [];

    const dataGraficoMes = safeData.map(item => ({
        ...item,
        mes: typeof item.mes === "number" ? mesesLabels[item.mes] : item.mes
    }));

    const dataGraficoSemana = safeData.map(item => ({
        ...item,
        semana: item.semana?.match(/Week\s*\d+/i)?.[0] || item.semana
    }));

    const dataGraficoDia = safeData.map(item => ({
        ...item,
        fecha: new Date(item.fecha).toLocaleDateString('es-ES', {
            day: '2-digit',
            month: 'short'
        })
    }));

    const dataArray = Array.isArray(data) ? data : [];

    const totalTransacciones = dataArray.reduce((acc, item) => acc + (item.transacciones || 0), 0);
    const totalGalones       = dataArray.reduce((acc, item) => acc + (item.galones || 0), 0);
    const totalImporte       = dataArray.reduce((acc, item) => acc + (item.importe || 0), 0);

/*     let dataConTotales = [...dataArray.map(item => ({ ...item }))];

    if (dataArray.length > 0) 
    {
        dataConTotales.push({
            id: 'totales',
            [campoActual.field]: 'TOTAL GENERAL',
            transacciones: totalTransacciones,
            galones: totalGalones,
            importe: totalImporte
        });
    } */

    /* let dataConTotales = [...dataArray];

    if (dataArray.length > 0) 
    {
        dataConTotales.push({
            id: 'totales',
            [campoActual.field]: 'TOTAL GENERAL',
            transacciones: totalTransacciones,
            galones: totalGalones,
            importe: totalImporte,
            esTotal: true
        });
    } */

    // Fila de totales
    const filaTotales = dataArray.length > 0 ? [{
        id: 'totales',
        [campoActual.field]: 'TOTAL GENERAL',
        transacciones: totalTransacciones,
        galones: totalGalones,
        importe: totalImporte,
        esTotal: true
    }] : [];

    // Combina datos normales + totales
    const filasParaTabla = useMemo(() => [...dataArray, ...filaTotales], [dataArray, filaTotales]);

    // Columnas con sort personalizado para mantener la fila de totales al final
    const columnasConSort = useMemo(() => columns.map(col => ({
        ...col,
        sortComparator: (v1, v2, param1, param2) => {
        const isTotal1 = param1?.row?.esTotal;
        const isTotal2 = param2?.row?.esTotal;

        if (isTotal1 && !isTotal2) return 1;    // total siempre al final
        if (!isTotal1 && isTotal2) return -1;
        // comparación normal
        return v1 > v2 ? 1 : v1 < v2 ? -1 : 0;
        }
    })), [columns]);

    const handleExportExcel = () => {
        const exportData = safeData.map(row => {
            const formattedRow = {};
    
            columns.forEach(col => {
                const value = row[col.field];
    
                // Aplicar la lógica de renderCell según tu ejemplo
                if (col.renderCell) {
                    // Aquí usamos la misma función que pasaste a renderCell
                    // Creamos un objeto params similar al que MUI DataGrid usa
                    const params = { value, row };
                    formattedRow[col.headerName || col.field] = col.renderCell(params);
                } else {
                    formattedRow[col.headerName || col.field] = value;
                }
            });
    
            return formattedRow;
        });
    
        // Crear worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Datos");
    
        // Generar y descargar Excel
        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(data, "datos.xlsx");
    };

    return (
        <>
        <Paper
            sx={{
                p: 2,
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                boxSizing: "border-box",
                overflow: "hidden",
            }}
        >
            <form
                onSubmit={(e) => e.preventDefault()}
                style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Grid
                    container
                    sx={{
                        height: '100%',
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Grid size={{ xs: 12, md: 12 }}>
                        <Typography variant="h4" fontWeight="bold" marginBottom={2}>
                            LOVES REPORT
                        </Typography>
                    </Grid>
                    <Grid
                        container
                        spacing={2}
                        size={12}
                        sx={{
                            flex: 1,
                            minHeight: 0,
                            overflow: 'hidden',
                        }}
                    >
                    <Grid
                        size={6}
                        marginTop={1}
                        sx={{
                            minHeight: 0,
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <FormControl variant="outlined" fullWidth>
                            <InputLabel id="tipoReporte-label" shrink={true}>Tipo de Reporte</InputLabel>
                            <Select
                                labelId="tipoReporte-label"
                                value={tipoReporte}
                                onChange={(e) => setTipoReporte(e.target.value)}
                                label="Tipo de Reporte"
                                displayEmpty
                                size="small"
                            >
                                <MenuItem value="0">CONSUMO TOTAL</MenuItem>
                                <MenuItem value="1">CONSUMO POR MES</MenuItem>
                                <MenuItem value="2">CONSUMO POR SEMANA</MenuItem>
                                <MenuItem value="3">CONSUMO POR DÍA</MenuItem>
                                <MenuItem value="4">CONSUMO TOP N</MenuItem>
                                <MenuItem value="5">CONSUMO POR OPERADOR</MenuItem>
                            </Select>
                        </FormControl>
                        <Typography variant="h6" fontWeight="bold" gutterBottom align="center">
                            {reportTitles[tipoReporte] || 'Consumo por Mes'}
                        </Typography>
                        {/* Contenedor para producto, mes y año */}
                        <Grid container spacing={2} alignItems="center">

                        {/* Operadores */}
                        <Grid item size={3}>
                            <Autocomplete
                            options={operadores}
                            getOptionLabel={(option) => (option?.label || '').toUpperCase()}
                            value={operadores.find(op => op.value === filtroOperador) || null}
                            onChange={(event, newValue) => setFiltroOperador(newValue?.value || '')}
                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                            renderOption={(props, option) => (
                                <li {...props}>{(option?.label || '').toUpperCase()}</li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Operador"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                    textTransform: 'uppercase',
                                }}
                                />
                            )}
                            />
                        </Grid>
                        
                        {/* Producto */}
                        <Grid item size={3}>
                            <Autocomplete
                            options={productos}
                            getOptionLabel={(option) => (option?.label || '').toUpperCase()}
                            value={productos.find(op => op.value === filtroProducto) || null}
                            onChange={(event, newValue) => setFiltroProducto(newValue?.value || '')}
                            isOptionEqualToValue={(option, value) => option.value === value?.value}
                            renderOption={(props, option) => (
                                <li {...props}>{(option?.label || '').toUpperCase()}</li>
                            )}
                            renderInput={(params) => (
                                <TextField
                                {...params}
                                label="Producto"
                                variant="outlined"
                                size="small"
                                fullWidth
                                sx={{
                                    textTransform: 'uppercase',
                                }}
                                />
                            )}
                            />
                        </Grid>
                        
                        

                        <Grid item size={3}>
                            <FormControl fullWidth size="small" variant="outlined">
                            <InputLabel id="mes-label">MES</InputLabel>
                            <Select
                                labelId="mes-label"
                                value={mesSeleccionado}
                                onChange={(e) => setMesSeleccionado(e.target.value)}
                                label="MES"
                            >
                                {meses.map((m) => (
                                <MenuItem key={m.value} value={m.value}>
                                    {m.label}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </Grid>

                        <Grid item size={3}>
                            <FormControl fullWidth size="small" variant="outlined">
                            <InputLabel id="anio-label">AÑO</InputLabel>
                            <Select
                                labelId="anio-label"
                                value={anioSeleccionado}
                                onChange={(e) => setAnioSeleccionado(e.target.value)}
                                label="AÑO"
                            >
                                <MenuItem key="0" value="0">TODOS</MenuItem>
                                {anios.map((a) => (
                                <MenuItem key={a} value={a}>
                                    {a}
                                </MenuItem>
                                ))}
                            </Select>
                            </FormControl>
                        </Grid>

                        {tipoReporte == 4 && (
                            <Grid item size={3}>
                                <TextField
                                    label="TOP N"
                                    type="number"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    value={topN}
                                    onChange={(e) => setTopN(e.target.value)}
                                    inputProps={{ min: 1 }}
                                />
                            </Grid>
                        )}


                        </Grid>
                        <Button
                            variant="contained"
                            onClick={handleExportExcel}
                            sx={{
                                mb: 1,
                                flexShrink: 0,
                                alignSelf: 'flex-start',
                            }}
                        >
                            Exportar a Excel
                        </Button>

                        <Box 
                            sx={{ 
                                width: "100%",
                                height: "calc(100vh - 375px)",
                                minHeight: 350,
                                display: "flex",
                                flexDirection: "column",
                                "& > div": {
                                    height: "100%",
                                    width: "100%"
                                }
                            }}
                        >
                            <MiTabla
                                columns={columnasConSort}
                                data={filasParaTabla}
                                loading={loading}
                                getRowClassName={(params) =>
                                    params.row?.esTotal ? "fila-total" : ""
                                }
                                disableRowSelectionOnClick
                            />
                        </Box>
                    </Grid>
                    <Grid size={6} marginTop={1}>

                        {tipoReporte === "1" && data.length > 0 && (
                            <Paper sx={{ marginTop: 4, padding: 2 }}>
                                <Typography variant="h6" align="center" gutterBottom>
                                Gráfico de Consumo Mensual
                                </Typography>
                                  {/* Contenedor con scroll horizontal */}
                                    <div style={{ overflowX: "auto", width: "100%" }}>
                                        {/* Ancho dinámico basado en cantidad de datos */}
                                        <div style={{ width: `${Math.max(data.length * 80, 600)}px`, height: 400 }}>
                                        <LineChart data={dataGraficoMes} width={Math.max(data.length * 80, 600)} height={400}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="mes" />
                                            <YAxis
                                            />
                                            <Tooltip
                                                formatter={(value, name) => {
                                                    if (name === "Importe" || name.toLowerCase().includes("importe")) {
                                                    return [
                                                        `$${value.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                        })}`,
                                                        name,
                                                    ];
                                                    } else {
                                                    return [
                                                        value.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                        }),
                                                        name,
                                                    ];
                                                    }
                                                }}
                                            />
                                            <Legend />
                                            <Line
                                            type="monotone"
                                            dataKey="galones"
                                            stroke="#8884d8"
                                            name="Galones"
                                            />
                                            <Line
                                            type="monotone"
                                            dataKey="importe"
                                            stroke="#82ca9d"
                                            name="Importe"
                                            />
                                        </LineChart>
                                        </div>
                                    </div>
                            </Paper>
                        )}
                        {tipoReporte === "2" && data.length > 0 && (
                            <Paper sx={{ marginTop: 4, padding: 2 }}>
                                <Typography variant="h6" align="center" gutterBottom>
                                Gráfico de Consumo Semanal
                                </Typography>
                                  {/* Contenedor con scroll horizontal */}
                                    <div style={{ overflowX: "auto", width: "100%" }}>
                                        {/* Ancho dinámico basado en cantidad de datos */}
                                        <div style={{ width: `${Math.max(data.length * 80, 600)}px`, height: 400 }}>
                                        <LineChart data={dataGraficoSemana} width={Math.max(data.length * 80, 600)} height={400}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="semana" />
                                            <YAxis
                                            />
                                            <Tooltip
                                                formatter={(value, name) => {
                                                    if (name === "Importe" || name.toLowerCase().includes("importe")) {
                                                    return [
                                                        `$${value.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                        })}`,
                                                        name,
                                                    ];
                                                    } else {
                                                    return [
                                                        value.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                        }),
                                                        name,
                                                    ];
                                                    }
                                                }}
                                            />
                                            <Legend />
                                            <Line
                                            type="monotone"
                                            dataKey="galones"
                                            stroke="#8884d8"
                                            name="Galones"
                                            />
                                            <Line
                                            type="monotone"
                                            dataKey="importe"
                                            stroke="#82ca9d"
                                            name="Importe"
                                            />
                                        </LineChart>
                                        </div>
                                    </div>
                            </Paper>
                        )}
                        {tipoReporte === "3" && data.length > 0 && (
                            <Paper sx={{ marginTop: 4, padding: 2 }}>
                                <Typography variant="h6" align="center" gutterBottom>
                                Gráfico de Consumo Diario
                                </Typography>
                                  {/* Contenedor con scroll horizontal */}
                                    <div style={{ overflowX: "auto", width: "100%" }}>
                                        {/* Ancho dinámico basado en cantidad de datos */}
                                        <div style={{ width: `${Math.max(data.length * 80, 600)}px`, height: 400 }}>
                                        <LineChart data={dataGraficoDia} width={Math.max(data.length * 80, 600)} height={400}>
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <XAxis dataKey="fecha" />
                                            <YAxis
                                            />
                                            <Tooltip
                                                formatter={(value, name) => {
                                                    if (name === "Importe" || name.toLowerCase().includes("importe")) {
                                                    return [
                                                        `$${value.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                        })}`,
                                                        name,
                                                    ];
                                                    } else {
                                                    return [
                                                        value.toLocaleString("en-US", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                        }),
                                                        name,
                                                    ];
                                                    }
                                                }}
                                            />
                                            <Legend />
                                            <Line
                                            type="monotone"
                                            dataKey="galones"
                                            stroke="#8884d8"
                                            name="Galones"
                                            />
                                            <Line
                                            type="monotone"
                                            dataKey="importe"
                                            stroke="#82ca9d"
                                            name="Importe"
                                            />
                                        </LineChart>
                                        </div>
                                    </div>
                            </Paper>
                        )}

                    </Grid>
                    </Grid>
                </Grid>
            </form>
        </Paper>
        </>
    )
}

export default Reporte_Loves